import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-edit',
	path: '/secure/admin/EditIssueType!default.jspa',
};
